import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSKoerperschaftDaten from './TSKoerperschaftDaten';

export default class TSKoerperschaft extends TSAbstractEntity implements TSSerializable<TSKoerperschaft> {

    private _koerperschaftDatenFS: TSKoerperschaftDaten;

    private _koerperschaftDatenGS: TSKoerperschaftDaten | undefined;

    public get koerperschaftDatenFS(): TSKoerperschaftDaten {
        return this._koerperschaftDatenFS;
    }

    public set koerperschaftDatenFS(value: TSKoerperschaftDaten) {
        this._koerperschaftDatenFS = value;
    }

    public get koerperschaftDatenGS(): TSKoerperschaftDaten|undefined {
        return this._koerperschaftDatenGS;
    }

    public set koerperschaftDatenGS(value: TSKoerperschaftDaten|undefined) {
        this._koerperschaftDatenGS = value;
    }

    deserialize(restObject: any): TSKoerperschaft {
        super.deserialize(restObject);

        this.koerperschaftDatenFS = this.deserializeOrCreate(restObject.koerperschaftDatenFS, new TSKoerperschaftDaten());
        this.koerperschaftDatenGS = this.deserializeOrNull(restObject.koerperschaftDatenGS, new TSKoerperschaftDaten());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.koerperschaftDatenFS = this.serializeOrInit(this.koerperschaftDatenFS, restObject.koerperschaftDatenFS);
        restObject.koerperschaftDatenGS = this.serializeOrInit(this.koerperschaftDatenGS, restObject.koerperschaftDatenGS);

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSKoerperschaft.ts